import React, { useState } from 'react';
import ChatApp from './ChatApp';
import { Card } from '../../../components/ui/card';
import { MessageCircle, Bell, CheckCircle } from 'lucide-react';

const ERPCommunication = () => {
  const [activeTab, setActiveTab] = useState('chat');

  return (
    <div className="p-6 max-w-7xl mx-auto h-full">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Communication Hub</h1>
          <p className="text-gray-600 mt-1">Internal messaging, notifications, and approvals</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="mb-6 border-b">
        <div className="flex gap-4">
          <button 
            onClick={() => setActiveTab('chat')} 
            className={`pb-3 px-4 font-medium flex items-center gap-2 ${
              activeTab === 'chat' 
                ? 'border-b-2 border-primary text-primary' 
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <MessageCircle size={18} />
            Internal Chat
          </button>
          <button 
            onClick={() => setActiveTab('notifications')} 
            className={`pb-3 px-4 font-medium flex items-center gap-2 ${
              activeTab === 'notifications' 
                ? 'border-b-2 border-primary text-primary' 
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <Bell size={18} />
            Notifications
          </button>
          <button 
            onClick={() => setActiveTab('approvals')} 
            className={`pb-3 px-4 font-medium flex items-center gap-2 ${
              activeTab === 'approvals' 
                ? 'border-b-2 border-primary text-primary' 
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <CheckCircle size={18} />
            Approvals
          </button>
        </div>
      </div>

      {/* Content */}
      {activeTab === 'chat' && <ChatApp />}
      
      {activeTab === 'notifications' && (
        <Card className="p-6">
          <h2 className="text-xl font-bold mb-4">Notifications</h2>
          <div className="text-center py-12 text-gray-500">
            <Bell size={48} className="mx-auto mb-3 text-gray-300" />
            <p>No notifications at the moment</p>
            <p className="text-sm">System notifications will appear here</p>
          </div>
        </Card>
      )}

      {activeTab === 'approvals' && (
        <Card className="p-6">
          <h2 className="text-xl font-bold mb-4">Approval Requests</h2>
          <div className="text-center py-12 text-gray-500">
            <CheckCircle size={48} className="mx-auto mb-3 text-gray-300" />
            <p>No pending approvals</p>
            <p className="text-sm">Approval requests will appear here</p>
          </div>
        </Card>
      )}
    </div>
  );
};

export default ERPCommunication;
